import NormesController from './normes.controller';

export default {
    template: require('./normes.tpl.html'),
    controller: NormesController
};
